import {
  color,
  shadow,
  spacing,
  Typography,
  Icon,
  Button
} from '@uniquegood/realworld-studio-design';
import { css } from '@emotion/react';
import { onMobile } from '@styles/responsive';

interface DisableCreateProjectProps {
  onClick: () => void;
  currentPlan: PlanType;
}

function DisableCreateProject({ onClick, currentPlan }: DisableCreateProjectProps) {
  return (
    <div css={ContainerStyle}>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: ${spacing.margin.large};

          ${onMobile} {
            gap: ${spacing.margin.small};
            height: auto;
          }
        `}
      >
        <Icon icon="question_circle_solid" size="20px" color="#1A1A1A" />
        <Typography
          type="heading"
          textColor="initial"
          cssStyle={css`
            ${onMobile} {
              font-size: 16px;
              line-height: 24px;
            }
          `}
        >
          콘텐츠를 더 만들고 싶으신가요?
        </Typography>
        <Typography type="button" textColor="subdued" cssStyle={DescriptionStyle}>
          요금제를 업그레이드하고 새 콘텐츠를 만드세요.
        </Typography>
      </div>
      <Button
        type="primary"
        size={onMobile ? 'small' : 'large'}
        onClick={onClick}
        cssStyle={css`
          background: linear-gradient(90deg, #7800ff 0%, #829bff 100%);
          color: ${color.white};
          width: 152px;
          height: 44px;
          border: 0;
        `}
      >
        {currentPlan === 'Free' ? '요금제 업그레이드' : '요금제 자세히 보기'}
      </Button>
    </div>
  );
}

export default DisableCreateProject;

const ContainerStyle = css`
  border-radius: ${spacing.borderRadius.xlarge};
  border: 1px solid ${color.border_default_subdued};
  background-color: ${color.surface_default_default};
  ${shadow.card};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 24px;
  height: 324px;

  ${onMobile} {
    width: 100%;
    height: 140px;
  }
`;

const DescriptionStyle = css`
  text-align: center;
  margin-bottom: ${spacing.margin.large};
`;
